import React from 'react';
import classnames from 'classnames';
import { CheckMarkIcon } from '../Icon';
export var Step = function Step(props) {
  var index = props.index,
      activeStep = props.activeStep,
      numberOfSteps = props.numberOfSteps,
      label = props.label,
      link = props.link;
  var isActive = index === activeStep;
  var isPassed = activeStep > index;
  return /*#__PURE__*/React.createElement("li", {
    className: "step-indicator__wrapper",
    key: "step-indicator-step-".concat(activeStep)
  }, /*#__PURE__*/React.createElement(StepElement, {
    isPassed: isPassed,
    onClick: function onClick() {
      return window.location.assign(link);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('step-indicator__step', {
      'step-indicator__step--active': isActive,
      'step-indicator__step--passed': isPassed
    })
  }, isPassed ? /*#__PURE__*/React.createElement("span", {
    className: "step-indicator__icon-wrapper"
  }, /*#__PURE__*/React.createElement(CheckMarkIcon, {
    className: "step-indicator__icon",
    title: "".concat(index + 1)
  })) : index + 1), /*#__PURE__*/React.createElement("span", {
    className: classnames('step-indicator__label', {
      'step-indicator__label--active': isActive
    })
  }, label, isPassed && /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "- fullf\xF8rt"))), /*#__PURE__*/React.createElement(Line, {
    index: index,
    numberOfSteps: numberOfSteps,
    activeStep: activeStep
  }));
};

var StepElement = function StepElement(_ref) {
  var children = _ref.children,
      isPassed = _ref.isPassed,
      onClick = _ref.onClick;

  if (isPassed) {
    return /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "step-indicator__element step-indicator__element__clickable",
      onClick: onClick
    }, children);
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "step-indicator__element"
    }, children);
  }
};

var Line = function Line(props) {
  var index = props.index,
      activeStep = props.activeStep,
      numberOfSteps = props.numberOfSteps;

  if (index >= numberOfSteps - 1) {
    return null;
  }

  var isPassed = activeStep > index;
  return /*#__PURE__*/React.createElement("span", {
    className: classnames('step-indicator__line', {
      'step-indicator__line--passed': isPassed
    })
  });
};